function formatDate(date?: Date | string) {
  return new Date(date || new Date()).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

function addTwoDaysDate(date: Date) {
  const newDate = new Date(date);
  return new Date(newDate.setDate(newDate.getDate() + 2));
}

function addSevenDaysDate(date: Date) {
  const newDate = new Date(date);
  return new Date(newDate.setDate(newDate.getDate() + 7));
}

function addOneMonthDate(date: Date) {
  const newDate = new Date(date);
  return new Date(newDate.setMonth(newDate.getMonth() + 1));
}

function addThreeMonthDate(date: Date) {
  const newDate = new Date(date);
  return new Date(newDate.setMonth(newDate.getMonth() + 3));
}

function addOneYearDate(date: Date) {
  const newDate = new Date(date);
  return new Date(newDate.setFullYear(newDate.getFullYear() + 1));
}

export const UtilityDate = {
  formatDate,
  addTwoDaysDate,
  addOneMonthDate,
  addThreeMonthDate,
  addOneYearDate,
  addSevenDaysDate,
};
